import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/landingPage/LandingPage";
import PartnerHomePage from "./components/puphubPartner/home/PartnerHomePage";
import AboutusPagePartner from './components/puphubPartner/about/AboutusPage';
import FAQPagePagePartner from './components/puphubPartner/faq/FaqPage';
import ContactusPagePartner from './components/puphubPartner/contact/ContactusPage';
import GalleryPage from "./components/puphubPartner/gallery/GalleryPage";
import HomePage from './components/puphub/home/HomePage';
import AboutusPage from './components/puphub/about/AboutusPage';
import BlogsPage from './components/puphub/blog/BlogsPage';
import FAQPage from './components/puphub/faq/FAQPage';
import ContactusPage from './components/puphub/contact/ContactusPage';
import { HelmetProvider } from "react-helmet-async";
import React from 'react';

const App: React.FC = () => {
  const isApiGateway =
 window.location.hostname.includes("execute-api");

const basename = isApiGateway ? "/prod" : "";
  return (
    <HelmetProvider>
      <BrowserRouter  basename={basename}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/puphub" element={<HomePage />} />
          <Route path="/aboutus" element={<AboutusPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/FAQ" element={<FAQPage />} />
          <Route path="/contactus" element={<ContactusPage />} />
          <Route path="/partner" element={<PartnerHomePage />} />
          <Route path="/partner-aboutus" element={<AboutusPagePartner />} />
          <Route path="/partner-faq" element={<FAQPagePagePartner />} />
          <Route path="/partner-contact" element={<ContactusPagePartner />} />
          <Route path="/gallery" element={<GalleryPage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;